import { render } from "./footer-contacts-list.vue?vue&type=template&id=26f7fec6"
import script from "./footer-contacts-list.vue?vue&type=script&lang=js"
export * from "./footer-contacts-list.vue?vue&type=script&lang=js"

import "./footer-contacts-list.vue?vue&type=style&index=0&id=26f7fec6&lang=scss"

import exportComponent from "C:\\Users\\yrabie\\Documents\\Projects\\Awsat Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__